<template>
    <div class="h-screen flex flex-col bg-grey-100" >
        <div class="flex flex-row w-full bg-white border-solid border-grey-200 border-b px-5 header-height">
            <div class="flex flex-grow items-center container mx-auto">
                <a href="javascript:void(0)" @click="movetoBackPage()"><i class="fas fa-chevron-left"></i></a> <slot name="header-bar"></slot>
            </div>
            <!-- <div class="flex items-center justify-center">
                <gd-button class="px-4 w-auto mr-2 exit" @click="exitScreen()">Exit</gd-button>
            </div> -->
        </div>
        <div class="flex w-full h-full">
            <div class="flex flex-row w-full max-h-full">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import GdLogo from '@groovepages/gd-ui-kit/assets/logo-extra-small.svg';
import directives from '@groovepages/gd-ui-kit/directives';


export default {
  props: ['menuItems'],
  data() {
    return {
    };
  },
  methods: {
    movetoBackPage() {
      this.$router.go(-1);
    }
  },
  components: {
    GdLogo,
  },
  directives,
  name: 'BaseLayout',
};
</script>
<style scoped>

.fa-chevron-left{
  color: #d5d8e5;
}
.header-height {
  min-height: 64px;
}
</style>

<style scoped>
@media (max-width: 767px) {
  .header-height:has(.gv-video-elements-actions) {
    flex: 0 0 auto;
    min-height: 108px;
  }

  .header-height:has(.gv-video-elements-actions) ::v-deep .gv-video-elements-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }

  .header-height:has(.gv-video-elements-actions) ::v-deep .gv-video-elements-actions button {
    min-height: 44px;
    padding: 8px 12px;
    margin-right: 0 !important;
  }

  /* defaultWithoutSidebarLogo normally reserves 4rem for a 64px header.
     Step 3 is the sole taller header: let the actual scroll container consume
     the remaining viewport height instead of overflowing beneath it. */
  .header-height:has(.gv-video-elements-actions) + div {
    min-height: 0;
  }

  .header-height:has(.gv-video-elements-actions) + div ::v-deep #groovesellCont {
    height: calc(100vh - 108px) !important;
    min-height: 0;
  }
}
</style>
